var _circle, _circle2, _g, _circle3, _circle4, _g2, _circle5, _circle6, _g3, _circle7, _circle8, _g4, _circle9, _circle10, _g5, _circle11, _circle12, _g6, _circle13, _circle14, _g7, _circle15, _circle16, _g8, _circle17, _circle18, _g9, _circle19, _circle20, _g10, _circle21, _circle22, _g11, _circle23, _circle24, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_43_1",
    "data-name": "Componente 43 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.882 294.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 265.771, 189.376)",
    fill: "#74d4ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 265.771, 142.413)",
    fill: "#9fd2ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(0 189.376) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510",
    "data-name": "Ellipse 510",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 46.963, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M0,24.064s6.935-6,14.4-6.058,13.365,5.305,15.009,6.416C29.649,22.268,32.294-1.033,29.3.036S24,5.164,14.4,5.164,0,.036,0,.036Z",
    transform: "translate(27.522 6.438)",
    fill: "#808fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-2",
    "data-name": "Ellipse 507",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 189.377, 29.11)",
    fill: "#74d4ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-2",
    "data-name": "Ellipse 508",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 142.414, 29.11)",
    fill: "#9fd2ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-2",
    "data-name": "Group 1493",
    transform: "translate(189.377 294.882) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-2",
    "data-name": "Ellipse 509",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-2",
    "data-name": "Ellipse 510",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 46.963, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-2",
    "data-name": "Path 922",
    d: "M0,24.064s6.935-6,14.4-6.058,13.366,5.305,15.009,6.416C29.649,22.268,32.294-1.033,29.3.036S24,5.164,14.4,5.164,0,.036,0,.036Z",
    transform: "translate(27.521 6.439)",
    fill: "#808fff"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-3",
    "data-name": "Ellipse 507",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "translate(34.115 201.458) rotate(30)",
    fill: "#74d4ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-3",
    "data-name": "Ellipse 508",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "translate(67.322 234.667) rotate(30)",
    fill: "#9fd2ff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-3",
    "data-name": "Group 1493",
    transform: "translate(222.043 13.53) rotate(45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-3",
    "data-name": "Ellipse 509",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-3",
    "data-name": "Ellipse 510",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 46.963, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-3",
    "data-name": "Path 922",
    d: "M0,24.064s6.936-6,14.4-6.058,13.366,5.305,15.009,6.416C29.65,22.268,32.3-1.033,29.3.036S24,5.164,14.4,5.164,0,.036,0,.036Z",
    transform: "translate(27.521 6.438)",
    fill: "#808fff"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-4",
    "data-name": "Ellipse 507",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "translate(201.459 260.766) rotate(-60)",
    fill: "#74d4ff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-4",
    "data-name": "Ellipse 508",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "translate(234.668 227.557) rotate(-60)",
    fill: "#9fd2ff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-4",
    "data-name": "Group 1493",
    transform: "translate(13.529 72.837) rotate(-45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-4",
    "data-name": "Ellipse 509",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-4",
    "data-name": "Ellipse 510",
    cx: 15.069,
    cy: 15.069,
    r: 15.069,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 46.963, 7.8)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-4",
    "data-name": "Path 922",
    d: "M0,24.064s6.936-6,14.4-6.058,13.366,5.305,15.009,6.416C29.65,22.268,32.3-1.033,29.3.036S24,5.164,14.4,5.164,0,.036,0,.036Z",
    transform: "translate(27.521 6.438)",
    fill: "#808fff"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-5",
    "data-name": "Ellipse 507",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "translate(182.422 220.831) rotate(-60)",
    fill: "#74d4ff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-5",
    "data-name": "Ellipse 508",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "translate(203.928 199.325) rotate(-60)",
    fill: "#9fd2ff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-5",
    "data-name": "Group 1493",
    transform: "translate(60.719 99.128) rotate(-45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-5",
    "data-name": "Ellipse 509",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-5",
    "data-name": "Ellipse 510",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 30.414, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-5",
    "data-name": "Path 922",
    d: "M0,15.584S4.491,11.7,9.327,11.66s8.656,3.436,9.72,4.155C19.2,14.421,20.914-.669,18.978.023s-3.435,3.321-9.65,3.321S0,.023,0,.023Z",
    transform: "translate(17.823 4.169)",
    fill: "#808fff"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-6",
    "data-name": "Ellipse 507",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "translate(220.83 112.458) rotate(-150)",
    fill: "#74d4ff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-6",
    "data-name": "Ellipse 508",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "translate(199.324 90.952) rotate(-150)",
    fill: "#9fd2ff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-6",
    "data-name": "Group 1493",
    transform: "translate(99.127 234.161) rotate(-135)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-6",
    "data-name": "Ellipse 509",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-6",
    "data-name": "Ellipse 510",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 30.414, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-6",
    "data-name": "Path 922",
    d: "M0,15.584S4.491,11.7,9.327,11.66s8.656,3.436,9.72,4.155C19.2,14.421,20.914-.669,18.977.023s-3.435,3.321-9.65,3.321S0,.023,0,.023Z",
    transform: "translate(17.823 4.169)",
    fill: "#808fff"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-7",
    "data-name": "Ellipse 507",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 70.809, 120.282)",
    fill: "#74d4ff"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-7",
    "data-name": "Ellipse 508",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 70.809, 150.696)",
    fill: "#9fd2ff"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-7",
    "data-name": "Group 1493",
    transform: "translate(242.924 120.282) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-7",
    "data-name": "Ellipse 509",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-7",
    "data-name": "Ellipse 510",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 30.414, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-7",
    "data-name": "Path 922",
    d: "M0,15.584S4.491,11.7,9.327,11.66s8.656,3.436,9.72,4.155C19.2,14.421,20.914-.669,18.978.023s-3.435,3.321-9.65,3.321S0,.023,0,.023Z",
    transform: "translate(17.823 4.169)",
    fill: "#808fff"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-8",
    "data-name": "Ellipse 507",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 120.281, 224.071)",
    fill: "#74d4ff"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-8",
    "data-name": "Ellipse 508",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 150.695, 224.071)",
    fill: "#9fd2ff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-8",
    "data-name": "Group 1493",
    transform: "translate(120.281 51.958)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-8",
    "data-name": "Ellipse 509",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-8",
    "data-name": "Ellipse 510",
    cx: 9.758,
    cy: 9.758,
    r: 9.758,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 30.414, 5.051)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-8",
    "data-name": "Path 922",
    d: "M0,15.585S4.491,11.7,9.327,11.661s8.656,3.436,9.72,4.155C19.2,14.422,20.914-.668,18.978.024s-3.435,3.321-9.65,3.321S0,.024,0,.024Z",
    transform: "translate(17.823 4.169)",
    fill: "#808fff"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-9",
    "data-name": "Ellipse 507",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 186.83, 161.401)",
    fill: "#9fd2ff"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-9",
    "data-name": "Ellipse 508",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 186.83, 145.766)",
    fill: "#74d4ff"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-9",
    "data-name": "Group 1493",
    transform: "translate(98.359 161.401) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-9",
    "data-name": "Ellipse 509",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 2.596)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-9",
    "data-name": "Ellipse 510",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 15.633, 2.596)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-9",
    "data-name": "Path 922",
    d: "M0,8.01A8.7,8.7,0,0,1,4.794,5.994c2.486-.018,4.449,1.766,5,2.136.079-.717.96-8.473-.036-8.118S7.989,1.719,4.794,1.719A6.768,6.768,0,0,1,0,.012Z",
    transform: "translate(9.161 2.143)",
    fill: "#808fff"
  }))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-10",
    "data-name": "Ellipse 507",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 161.4, 108.05)",
    fill: "#9fd2ff"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-10",
    "data-name": "Ellipse 508",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 145.768, 108.05)",
    fill: "#74d4ff"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-10",
    "data-name": "Group 1493",
    transform: "translate(161.4 196.52) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-10",
    "data-name": "Ellipse 509",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 2.596)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-10",
    "data-name": "Ellipse 510",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 15.633, 2.596)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-10",
    "data-name": "Path 922",
    d: "M0,8.011A8.7,8.7,0,0,1,4.794,5.994c2.486-.018,4.449,1.766,5,2.136.079-.717.96-8.474-.036-8.118S7.989,1.719,4.794,1.719A6.768,6.768,0,0,1,0,.012Z",
    transform: "translate(9.161 2.143)",
    fill: "#808fff"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-11",
    "data-name": "Ellipse 507",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "translate(109.717 165.423) rotate(30)",
    fill: "#9fd2ff"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-11",
    "data-name": "Ellipse 508",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "translate(120.771 176.477) rotate(30)",
    fill: "#74d4ff"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-11",
    "data-name": "Group 1493",
    transform: "translate(172.273 102.864) rotate(45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-11",
    "data-name": "Ellipse 509",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 2.596)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-11",
    "data-name": "Ellipse 510",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 15.633, 2.597)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-11",
    "data-name": "Path 922",
    d: "M0,8.01A8.7,8.7,0,0,1,4.794,5.994c2.486-.018,4.449,1.766,5,2.136.079-.717.96-8.473-.036-8.118S7.989,1.719,4.794,1.719A6.768,6.768,0,0,1,0,.012Z",
    transform: "translate(9.161 2.143)",
    fill: "#808fff"
  }))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507-12",
    "data-name": "Ellipse 507",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "translate(165.422 185.165) rotate(-60)",
    fill: "#9fd2ff"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508-12",
    "data-name": "Ellipse 508",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "translate(176.477 174.11) rotate(-60)",
    fill: "#74d4ff"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1493-12",
    "data-name": "Group 1493",
    transform: "translate(102.863 122.606) rotate(-45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509-12",
    "data-name": "Ellipse 509",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 2.597)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510-12",
    "data-name": "Ellipse 510",
    cx: 5.016,
    cy: 5.016,
    r: 5.016,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 15.633, 2.596)",
    fill: "#808fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922-12",
    "data-name": "Path 922",
    d: "M0,8.01A8.7,8.7,0,0,1,4.794,5.994c2.486-.018,4.449,1.766,5,2.136.079-.717.96-8.473-.036-8.118S7.989,1.719,4.794,1.719A6.768,6.768,0,0,1,0,.012Z",
    transform: "translate(9.161 2.143)",
    fill: "#808fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiImage);
export default __webpack_public_path__ + "static/media/ai-image.be8ecc7341fa4417049edbae47fbf361.svg";
export { ForwardRef as ReactComponent };